import styled, { css } from "styled-components";

export const Kpi = styled.div`
  display: grid;
  grid-template-rows: 2fr 0.05fr 3fr;
  grid-gap: 10px;

  background-color: ${({ theme }) => theme.colors.primary.orange};

  padding: 10px;

  min-width: 150px;
  height: 130px;

  span {
    font-size: 15px;
    color: ${({ theme }) => theme.colors.neutral.white};
    font-weight: bold;
    height: 44px;
  }

  hr {
    border: 0.3px solid ${({ theme }) => theme.colors.neutral.white};
  }

  h3 {
    font-size: 24px;
    color: ${({ theme }) => theme.colors.neutral.white};
    margin-top: 10px;
  }

  /* Cartão com ação: como o elemento passa a ser um <button>, é preciso zerar a
     aparência nativa (borda, fonte herdada, alinhamento) para ele continuar
     idêntico ao cartão inerte.

     A prop é TRANSIENTE ($): sem o prefixo, o styled-components v6 a repassa para
     o DOM e o React reclama de atributo não-booleano. */
  ${({ $clickable }) =>
    $clickable &&
    css`
      border: none;
      font-family: inherit;
      text-align: left;
      cursor: pointer;

      &:hover {
        filter: brightness(1.08);
      }

      &:focus-visible {
        outline: 2px solid #ffffff;
        outline-offset: 2px;
      }
    `}
`;
